import { render, staticRenderFns } from "./workExp.vue?vue&type=template&id=4279448e&scoped=true&"
import script from "./workExp.vue?vue&type=script&lang=js&"
export * from "./workExp.vue?vue&type=script&lang=js&"
import style0 from "./workExp.vue?vue&type=style&index=0&id=4279448e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279448e",
  null
  
)

export default component.exports